import { CreditCard } from 'lucide-react';
import { type PaymentMethodTranslations } from './types';

interface EmptyCardListProps {
  t: PaymentMethodTranslations;
}

export function EmptyCardList({ t }: EmptyCardListProps) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <CreditCard className="w-12 h-12 text-muted-foreground mb-3" />
      <p className="text-foreground mb-1">
        {t.noCards}
      </p>
      <p className="text-muted-foreground text-sm">
        {t.addFirstCard}
      </p>
    </div>
  );
}
